// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import {
    getGroupsContacts as listGroupsContactsAPI,
    getGroupsContact as getGroupsContactAPI,
    addGroupsContact as addGroupsContactAPI,
    updateGroupsContact as updateGroupsContactAPI,
    deleteGroupsContact as deleteGroupsContactAPI,
} from '../../helpers/';

import { groupsContactsApiResponseError, groupsContactsApiResponseSuccess } from './actions';
import { GroupsContactsActionTypes } from './constants';

function* getGroupsContact({ payload: { id } }) {
    try {
        const response = yield call(getGroupsContactAPI, id );
        const groupsContactItem = response.data.data;
        yield put(groupsContactsApiResponseSuccess(GroupsContactsActionTypes.GET_GROUPS_CONTACTS, groupsContactItem));
    } catch (error) {
        yield put(groupsContactsApiResponseError(GroupsContactsActionTypes.GET_GROUPS_CONTACTS, error));
    }
}

function* addGroupsContact({payload:groupsContact}){
    try{
        const response = yield call(addGroupsContactAPI,{...groupsContact})
        const groupsContactItem = response.data
        yield put(groupsContactsApiResponseSuccess(GroupsContactsActionTypes.ADD_GROUPS_CONTACTS,groupsContactItem))
    } catch(error){
        yield put(groupsContactsApiResponseError(GroupsContactsActionTypes.ADD_GROUPS_CONTACTS,error))
    }
}

function* updateGroupsContact({payload:groupsContact}){
    try{
        const response = yield call(updateGroupsContactAPI,{...groupsContact})
        const groupsContactItem = response.data.data
        yield put(groupsContactsApiResponseSuccess(GroupsContactsActionTypes.UPDATE_GROUPS_CONTACTS,groupsContactItem))
    }catch(error){
        yield put(groupsContactsApiResponseError(GroupsContactsActionTypes.UPDATE_GROUPS_CONTACTS,error))
    }
}
function* deleteGroupsContact({payload:{id}}){
    try{
        const response = yield call(deleteGroupsContactAPI,id)
        const groupsContactItem = response.data.id
        yield put(groupsContactsApiResponseSuccess(GroupsContactsActionTypes.DELETE_GROUPS_CONTACTS,groupsContactItem))
    }catch(error){
        yield put(groupsContactsApiResponseError(GroupsContactsActionTypes.DELETE_GROUPS_CONTACTS,error))
    }
}

/**
 * List contactos
 */
function* listGroupsContacts({payload:params}) {
    try {
        const response = yield call(listGroupsContactsAPI, { ...params });
        const listaGroupsContacts = response.data.data;
        yield put(groupsContactsApiResponseSuccess(GroupsContactsActionTypes.LIST_GROUPS_CONTACTS, listaGroupsContacts));
    } catch (error) {
        yield put(groupsContactsApiResponseError(GroupsContactsActionTypes.LIST_GROUPS_CONTACTS, error));
    }
}


export function* watchGetGroupsContact(): any {
    yield takeEvery(GroupsContactsActionTypes.GET_GROUPS_CONTACTS, getGroupsContact);
}

export function* watchListGroupsContacts(): any {
    yield takeEvery(GroupsContactsActionTypes.LIST_GROUPS_CONTACTS, listGroupsContacts);
}

export function* watchAddGroupsContact():any{
    yield takeEvery(GroupsContactsActionTypes.ADD_GROUPS_CONTACTS, addGroupsContact)
}
export function* watchUpdateGroupsContact():any{
    yield takeEvery(GroupsContactsActionTypes.UPDATE_GROUPS_CONTACTS, updateGroupsContact)
}
export function* watchDeleteGroupsContact():any{
    yield takeEvery(GroupsContactsActionTypes.DELETE_GROUPS_CONTACTS, deleteGroupsContact)
}


function* groupsContactsSaga(): any {
    yield all([
        fork(watchGetGroupsContact),
        fork(watchListGroupsContacts),
        fork(watchAddGroupsContact),
        fork(watchUpdateGroupsContact),
        fork(watchDeleteGroupsContact),
    ]);
}

export default groupsContactsSaga;
